export const aiStudioModules = [
  {
    description: 'Follow every generation, validation, retry, and review handoff in one operational queue.',
    icon: 'pending_actions',
    id: 'ai-studio-generation-jobs',
    label: 'Generation queue',
  },
  {
    description: 'Create, review, and publish AI-generated mock exams.',
    icon: 'quiz',
    id: 'ai-studio-assisted-mock-exams',
    label: 'Mock exams',
  },
  {
    description: 'Generate and review standalone Question Bank content with support ladders.',
    icon: 'contact_support',
    id: 'ai-studio-questions',
    label: 'Questions',
  },
  {
    description: 'Create and review predicted papers using the AI Studio assessment workflow.',
    icon: 'fact_check',
    id: 'ai-studio-predicted-papers',
    label: 'Predicted papers',
  },
  {
    description: 'Review generated topic drafts before publishing them into the curriculum.',
    icon: 'library_books',
    id: 'ai-studio-topic-generation',
    label: 'Topic generation',
  },
  {
    description: 'Review generated unit drafts and their curriculum placement.',
    icon: 'segment',
    id: 'ai-studio-unit-generation',
    label: 'Unit generation',
  },
  {
    description: 'Manage the MCP connector and the OAuth clients ChatGPT uses.',
    icon: 'settings',
    id: 'ai-integrations',
    label: 'MCP setup',
  },
];

export const aiStudioModuleNavigationItems = aiStudioModules.map(({ description, id, label }) => ({
  description,
  id,
  label,
  title: label,
}));
